import React from 'react';
import './Skeletons.css';

const DateCarouselSkeleton = () => {
    return (
        <div className="date-carousel-skeleton-wrapper">
            {/* Left Arrow Space */}
            <div style={{ width: '40px' }}></div>

            {/* 7 Date Pills */}
            <div style={{ display: 'flex', gap: '10px', flex: 1, justifyContent: 'center' }}>
                {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                    <div key={i} className="date-skeleton-item shimmer-bg"></div>
                ))}
            </div>

            {/* Right Arrow Space */}
            <div style={{ width: '40px' }}></div>
        </div>
    );
};

export default DateCarouselSkeleton;
